import { useState } from 'react';
import logo from '../../../src/assets/images/logos/DeltaConnect_Logo.svg';
import { Box, Button, CircularProgress, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GetSupport from '../GetSupport';
import { MixpanelWrapper } from '../MixPanelWrapper';
import { currentEnv } from '../../helper/endpoints';
import { colours } from '../../shared/colors';
import { useLogoutMutation } from '../../services/features/authApi/authApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

/**
 * Component for the header section.
 *
 * This component displays the header of the application, including the logo, "Get Support" link,
 * and "Log out" link for authenticated users. It also provides a support modal for user inquiries
 * and tracks user interactions with Mixpanel.
 *
 * @returns {JSX.Element} The rendered header UI.
 */
const Header = () => {
	const theme = useTheme();

	const brokerId = useSelector((state: RootState) => state.authSlice.id);

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [logout, { isLoading }] = useLogoutMutation();
	/**
	 * State to manage the visibility of the support modal.
	 */
	const [supportModalOpen, setSupportModalOpen] = useState(false);

	/**
	 * Function to open the support modal and track the "Get Support" event.
	 */
	const handleOpenSupportModal = () => {
		MixpanelWrapper.track('Get Support');
		setSupportModalOpen(true);
	};

	/**
	 * Function to close the support modal.
	 */
	const handleCloseSupportModal = () => setSupportModalOpen(false);

	const navigate = useNavigate();

	/**
	 * Function to log out the user and update the loading state.
	 */
	const logoutUser = async () => {
		// if (!loading) {
		// setLoading(true);
		await logout(undefined)
			.unwrap()
			.catch((e) => console.log('Error logging out', e))
			.then((r) => console.log('Successfully logged out', r));
		// setLoading(false);
		// }
	};

	return (
		<>
			<Grid
				height='7vh'
				container
				px={3}
				sx={{ backgroundColor: '#fff' }}
				alignItems='center'
			>
				<Grid item xs={true} sm={3} md={2} px={1}>
					<Box
						height={'100%'}
						width='100%'
						onClick={() => navigate('/')}
						sx={{ cursor: 'pointer' }}
					>
						<img src={logo} alt='logo' />
					</Box>
				</Grid>
				<Grid item xs={true} />
				<Grid item container xs={5} sm={4} lg={3} justifyContent='end'>
					<Grid item xs={6} px={1}>
						<Button
							variant='greenFilled'
							onClick={handleOpenSupportModal}
							sx={{ width: '100%' }}
						>
							{brokerId != null ? 'Get support' : 'Contact us'}
						</Button>
					</Grid>
					{brokerId != null && (
						<Grid item xs={6} px={1}>
							<Button
								variant='text'
								onClick={logoutUser}
								sx={{ width: '100%', color: '#474848' }}
							>
								{isLoading ? (
									<CircularProgress
										size='2em'
										sx={{ color: colours.primary.main }}
									/>
								) : (
									<u>{'Log out'}</u>
								)}
							</Button>
						</Grid>
					)}
				</Grid>
			</Grid>
			{supportModalOpen && (
				<GetSupport
					open={supportModalOpen}
					handleOpen={handleOpenSupportModal}
					handleClose={handleCloseSupportModal}
				/>
			)}
		</>
	);
};

export default Header;
